import React from 'react';

import PDFThumbnail from '@/components/atoms/PDFThumbnail';

interface WorkActivityDocumentsProps {
  documents: string[];
}

const isPdfFile = (url: string): boolean => url.toLowerCase().endsWith('.pdf');

const openFileInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

const WorkActivityDocuments = ({ documents }: WorkActivityDocumentsProps) => {
  if (!documents.length) {
    return <p className="text-sm font-medium text-secondary">No documents uploaded for this work activity</p>;
  }

  return (
    <div className="flex gap-2 flex-wrap">
      {documents.map((fileUrl, index) => {
        if (isPdfFile(fileUrl)) {
          return (
            <PDFThumbnail
              key={`${fileUrl}-${index}`}
              url={fileUrl}
              onClick={() => openFileInNewTab(fileUrl)}
              width={68}
              height={68}
            />
          );
        }

        return (
          <img
            src={fileUrl}
            key={`${fileUrl}-${index}`}
            alt="work-activity-document"
            onClick={() => openFileInNewTab(fileUrl)}
            className="w-[68px] h-[68px] rounded-[8px] object-cover border border-secondary cursor-pointer hover:opacity-80 transition-opacity"
            title="Click to open document"
          />
        );
      })}
    </div>
  );
};

export default WorkActivityDocuments;
